import { render } from "./GptIndex.vue?vue&type=template&id=7c1d5d4b&scoped=true"
import script from "./GptIndex.vue?vue&type=script&lang=js"
export * from "./GptIndex.vue?vue&type=script&lang=js"

import "./GptIndex.vue?vue&type=style&index=0&id=7c1d5d4b&scoped=true&lang=less"

import exportComponent from "D:\\zyr\\gptm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c1d5d4b"]])

export default __exports__